"use client";

import { InputAdornment, styled } from "@mui/material";
import MuiTextField from "@mui/material/TextField";
import { CircleAlert } from "lucide-react";
import styles from "./TextField.module.css";

const CustomTextField = styled(MuiTextField, {
  shouldForwardProp: (prop) => !["borderColor", "isError"].includes(prop),
})(({ fullWidth, borderColor, isError, multiline }) => ({
  width: fullWidth ? "100%" : "400px",
  height: multiline ? "auto" : "40px",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "white",
    "& fieldset": {
      borderColor: isError ? "error.main" : borderColor,
      borderWidth: isError ? "2px" : "1px",
    },
    "&:hover fieldset": {
      borderColor: "primary.main",
    },
  },
}));

export default function TextField({
  startIcon,
  endIcon,
  label,
  value,
  onChange,
  isBlueBorder,
  isError,
  helperText,
  ...props
}) {
  const borderColor = isBlueBorder ? "primary.light" : "black.main";

  // Ensure value is never null - convert null/undefined to empty string
  const safeValue = value ?? "";

  return (
    <CustomTextField
      InputProps={{
        startAdornment: startIcon ? (
          <InputAdornment position="start">{startIcon}</InputAdornment>
        ) : null,
        endAdornment: endIcon ? (
          <InputAdornment position="end">{endIcon}</InputAdornment>
        ) : null,
        style: { height: props.multiline ? "auto" : "40px" },
      }}
      label={label}
      variant="outlined"
      borderColor={borderColor}
      isError={isError}
      value={safeValue}
      onChange={onChange}
      {...props}
      helperText={
        isError && helperText ? (
          <span className={styles.errorText}>
            <CircleAlert size={14} className={styles.errorIcon} aria-hidden="true" />
            {helperText}
          </span>
        ) : (
          helperText
        )
      }
    />
  );
}
